import { CART_REVAMP_TRACKER_TYPE } from '../../../../shop/constants/tracker';
import { getInjector } from '../../utils/getInjector';

/**
 * @param {object} payload
 * @param {string} payload.page_type - The page type where the event is triggered
 * @param {string} payload.product_id - The product ID of the recommended item
 * @param {string[]} [payload.based_product_ids] - The product IDs of the based products for the recommendation (optional)
 * @param {string} [payload.rec_strategy] - The recommendation strategy used for the recommended item (optional)
 * @param {number} [payload.rank] - The rank of the recommended item
 * @param {string} [payload.layout_setting] - The layout setting of the recommendation. `horizontal_scroll`, `full`.
 */
export const onTrackRecommendItem = async ({
  page_type,
  product_id,
  based_product_ids,
  rec_strategy,
  rank,
  layout_setting,
}) => {
  const injector = await getInjector();
  const trackerService = injector.get('trackerService');

  trackerService.track({
    type: CART_REVAMP_TRACKER_TYPE.RecommendItem,
    data: {
      page_type,
      product_id,
      rank,
      layout_setting,
      ...(based_product_ids?.length && { based_product_ids }),
      ...(rec_strategy && { rec_strategy }),
    },
  });
};
